import React, { useState } from 'react';
import { PartQuote } from 'types';
import { useAddProductToRemoteCartMutation } from 'api';
import { ComposeCartItem } from 'components/MachinePartsTable/CartHelp';
import { Product } from 'types/parts';
import { useDispatch } from 'react-redux';
import { cartActions } from 'actions';
import { UNIVERSAL_PRODUCTS_KEY } from 'constants/cart';
import { CartItem } from 'types/parts/cart';
import { ToastMsg } from 'common/components/Toast';


export const useQuoteContextMenuState = () => {
  const [contextMenuPosition, setContextMenuPosition] = useState<{ top: number; left: number } | null>(null);
  const [selectedQuote, setSelectedQuote] = useState<PartQuote | null>(null);



  const openContextMenu = (position: { top: number; left: number }, quote: PartQuote) => {
    setContextMenuPosition(position);
    setSelectedQuote(quote);
  };
  const [AddProductToRemoteCart] = useAddProductToRemoteCartMutation();
  const closeContextMenu = () => {
    setContextMenuPosition(null);
    setSelectedQuote(null);
  };
  const dispatch = useDispatch();
  // Empty click event handlers for menu items
  const handleAddQuoteToCart = (quote: PartQuote) => {
 
    if (quote !== undefined) {
         // change sfOrders to point twoway order object
         quote.parts?.forEach((item) => {
           const product: Product = {
             id: item.partId as string,
             description: item.description as string,
             sku: item.sku as string,
             price: Number(item.unitPrice),
             priceUnit: item.currency as string,
             isPurchasable: true,
             leadTime: item?.leadTime || 0,
             stock: item?.stock || 1,
             businessUnit: 'proseal'
           };
           AddProductToRemoteCart([ComposeCartItem(product, item.machineId as string, item.machineName as string)] as CartItem[])
                 .unwrap()
                 .then(() => {
                                   // maintain temporay FE cartState to track cart count
                         dispatch({
                             type: cartActions.ADD_TO_CART,
                             item: product,
                             quantity: item.quantity,
                             groupId:
                               item.machineInfo !== undefined
                                 ? item.machineId
                                   ? item.machineId
                                   : UNIVERSAL_PRODUCTS_KEY
                                 : UNIVERSAL_PRODUCTS_KEY,
                             groupDescription:
                               item.machineInfo !== undefined
                                 ? item.machineName
                                   ? item.machineName
                                   : UNIVERSAL_PRODUCTS_KEY
                                 : UNIVERSAL_PRODUCTS_KEY
                           });
                     })
                 .catch((error) => {
                      console.warn('Error adding item to cart: ', error);
                 });
   
         
         });
       }
    closeContextMenu();
  };

  const handleDeleteQuote = (quote: PartQuote) => {
    console.log('Delete quote:', quote);
    closeContextMenu();
  };

  return {
    contextMenuPosition,
    selectedQuote,
    openContextMenu,
    closeContextMenu,
    handleAddQuoteToCart,
    handleDeleteQuote
  };
};


